import { Link, useNavigate } from "react-router-dom";
import useScroll from "../../Hooks/useScroll";
import PopCart from "../PopCart/PopCart";
import logo from "../../Images/earth-beauty-you-logo.png";
import SearchedProducts from "../SearchedProducts/SearchedProducts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import Cart from "../Cart/Cart";
import { useState, useContext } from "react";
import { ThemeContext } from "../../Contexts/ThemeContext";
import AllProducts from "../NavCategories/AllProducts";

const LargeCategory = ({ popCart, handlePopCart }) => {
  const { products, searchText, setSearchText } = useContext(ThemeContext);
  const otpUser = JSON.parse(localStorage.getItem("user"));
  const [focus, setFocus] = useState(false);
  const [scrollPosition] = useScroll();
  const navigate = useNavigate();

  // ✅ Filter search results only if >2 chars
  const searchedProducts =
    searchText.length > 2
      ? products?.filter((product) =>
          product.name.toLowerCase().includes(searchText?.toLowerCase()),
        )
      : [];

  const highPriorityProducts = [];

  return (
    <div>
      {/* ✅ SEO-friendly top banner */}
      <div className="bg-accent text-sm flex justify-center py-1 text-primary font-medium  lg:flex tracking-wide">
        {/* Get Free Delivery on Orders Over BDT 1499+ */}
        Nature Skin Care — Pure Nature. Healthy Glow. For Everyday Skincare And Beauty.
        {/* Nature Skin Care — Pure Nature. Healthy Glow. Nature-inspired formulas */}

      </div>

      <div
        className={`nav-menu relative hidden lg:flex transition-all ease-in-out duration-300 text-center py-10 text-white nav-menu-scrolled border-b border-secondary`}
      >
        {/* ✅ Pop-up cart */}
        <PopCart handlePopCart={handlePopCart} popCart={popCart} />

        {/* ✅ Logo with descriptive alt/title */}
        <Link to="/" aria-label="Earth Beauty & You Homepage">
          <img
            className="ms-10 w-[100px] absolute top-[6px] left-0"
            src="https://i.ibb.co.com/rRSmvGw5/ebay-logo.jpg"
            alt="Earth Beauty & You official logo"
            width={334}
            height={201}
            title="Earth Beauty & You – Organic Skincare & Haircare"
            loading="lazy"
          />
        </Link>

        {/* ✅ Main Navigation Links */}
        <div className="all-menu">
          {/* ✅ Category dropdown menu */}
          <AllProducts />

          <Link
            to="/newarrivals"
            title="Shop New Arrivals - Latest Skincare & Haircare Products"
            className={`mr-10 block font-bold ${
              scrollPosition > 80
                ? "hover:text-accent text-secondary"
                : "text-secondary hover:text-accent"
            }`}
          >
            NEW ARRIVALS
          </Link>

          <Link
            to="/blogs"
            title="Read our latest skincare & beauty blogs"
            className={`mr-10 block font-bold ${
              scrollPosition > 80
                ? "hover:text-accent text-secondary"
                : "text-secondary hover:text-accent"
            }`}
          >
            BLOGS
          </Link>

          <Link
            to="/about"
            title="Learn more about Earth Beauty & You"
            className={`mr-10 block font-bold ${
              scrollPosition > 80
                ? "hover:text-accent text-secondary"
                : "text-secondary hover:text-accent"
            }`}
          >
            ABOUT US
          </Link>

          {/* <Link
            to="https://wholesale.luvit.com.bd/search/Earth%20Beauty%20&%20You"
            Target="_blank"
            title="Learn more about Earth Beauty & You"
            className={`mr-10 block font-bold ${
              scrollPosition > 80
                ? "hover:text-accent text-secondary"
                : "text-secondary hover:text-accent"
            }`}
          >
            WHOLESALE
          </Link> */}
        </div>

        {/* ✅ Search Bar with accessible label */}
        <div className="form-control text-black 2xl:w-[30%] lg:w-[20%] relative">
          <form
            className="input-group"
            role="search"
            aria-label="Site Search"
            onSubmit={(e) => {
              e.preventDefault();
              navigate(`/search/${searchText}`);
              setFocus(false);
            }}
          >
            <label htmlFor="desktop-search" className="sr-only">
              Search Earth Beauty & You products
            </label>
            <input
              id="desktop-search"
              type="text"
              className="border border-r-0  border-[#e0dddd] w-full px-4"
              placeholder="Search for natural skincare & haircare..."
              value={searchText}
              onFocus={() => setFocus(true)}
              onBlur={() => setTimeout(() => setFocus(false), 200)}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <button
              type="submit"
              aria-label="Search"
              className="btn btn-rounded bg-primary border border-l-0 border-[#cccccc]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 hover:text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </form>

          {/* ✅ Search Result Suggestions */}
          <SearchedProducts
            highPriorityProducts={highPriorityProducts}
            searchedProducts={searchedProducts}
            focus={focus}
          />
        </div>

        {/* ✅ External Partner Link */}
        {/* <a
          href="https://luvit.com.bd"
          target="_blank"
          rel="noopener noreferrer"
          title="Visit our partner site Luvit"
        >
          <img
            className="w-[60px] ml-10"
            src="https://luvit.com.bd/wp-content/uploads/2025/11/luvitlogo-400x183.png"
            alt="Luvit Official Logo"
            width={200}
            height={100}
            loading="lazy"
          />
        </a> */}

        {/* <Link
          to="/reseller-dashboard"
          aria-label="reseller"
          title="reseller"
          className="ml-10 font-bold bg-secondary p-2 px-3 rounded"
        >
          Reseller Panel
        </Link> */}

        {/* ✅ User + Cart Section */}
        <div>
          <div className="cart-icon mobile-cart-position top-[55px] right-[40px]">
            {otpUser?.phone ? (
              <Link
                to="/dashboard"
                aria-label="Go to My Account"
                title="My Account"
                className="hover:text-accent"
              >
                <FontAwesomeIcon
                  className="text-[24px] mr-10 mb-2"
                  icon={faUser}
                />
              </Link>
            ) : (
              <Link
                to="/customerDashboard"
                aria-label="Login or Register"
                title="Login / Register"
                className="hover:text-accent"
              >
                <FontAwesomeIcon
                  className="text-[24px] mr-10 mb-2"
                  icon={faUser}
                />
              </Link>
            )}
          </div>

          {/* ✅ Cart Component */}
          <Cart popCart={popCart} handlePopCart={handlePopCart} />
        </div>
      </div>
    </div>
  );
};

export default LargeCategory;
